import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './CreateOffer.css'; // We can reuse the same CSS

const SERVER_URL = process.env.REACT_APP_TEST_API_URL;

const EditOffer = () => {
  const { id } = useParams();
//   console.log(useParams())
//   console.log(id)
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });

  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [message, setMessage] = useState({ text: '', type: '' });

  // Fetch offer data when component mounts
  useEffect(() => {
    const fetchOffer = async () => {
      try {
        const response = await fetch(`${SERVER_URL}/api/offer/getOne/${id}`);
        if (!response.ok) {
          throw new Error('Failed to fetch offer');
        }        
        const offer = await response.json();
        setFormData({
          name: offer.name,
          description: offer.description
        });
        if (offer.imageUrl) {
          setCurrentImage(`${SERVER_URL}/${offer.imageUrl}`);
          setPreview(`${SERVER_URL}/${offer.imageUrl}`);
        }
      } catch (error) {
        console.error('Error fetching offer:', error);
        setMessage({ text: 'Failed to load offer data', type: 'error' });
      } finally {
        setFetchLoading(false);
      }
    };
    fetchOffer();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (!selectedFile.type.match('image.*')) {
        setMessage({ text: 'Please select an image file', type: 'error' });
        return;
      }
      
      setFile(selectedFile);
      
      // Create preview URL
      const reader = new FileReader();
      reader.onload = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setLoading(true);
    setMessage({ text: '', type: '' });
    
    try {
      // Create FormData object for multipart/form-data submission
      const submitData = new FormData();
      submitData.append('name', formData.name);
      submitData.append('description', formData.description);
      
      // Only append file if a new one was selected
      if (file) {
        submitData.append('image', file);
      }
      // Use PUT request for updating existing resource
      const response = await fetch(`${SERVER_URL}/api/offer/update/${id}`, {
        method: 'PUT',
        body: submitData,
      });
      
      if (response.ok) {
        setMessage({ text: 'Offer updated successfully!', type: 'success' });
        // Navigate back to offers list after successful update
        setTimeout(() => {
          navigate('/offers');
        }, 2000);
      } else {
        const error = await response.json();
        setMessage({ text: error.message || 'Failed to update offer', type: 'error' });
      }
    } catch (error) {
      setMessage({ text: 'An error occurred. Please try again.', type: 'error' });
      console.error('Form submission error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/offers');
  };

  if (fetchLoading) {
    return (
      <div className="create-offer-container">
        <div className="create-offer-form loading-container">
          <div className="loading-spinner"></div>
          <p>Loading offer data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="create-offer-container">
      <div className="create-offer-form">
        <h2>Edit Offer</h2>
        
        {message.text && (
          <div className={`message ${message.type === 'success' ? 'success' : 'error'}`}>
            {message.text}
          </div>
        )}
        
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="form-group">
            <label htmlFor="name">Offer Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter offer name"
              maxLength="100"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              required
              rows="4"
              placeholder="Describe your offer..."
              maxLength="500"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="image">
              Offer Image 
              {!file && currentImage && <span className="image-note">(Keep current image or select new)</span>}
            </label>
            <div className="image-upload-area">
              {preview ? (
                <div className="image-preview">
                  <img src={preview} alt="Preview" />
                </div>
              ) : (
                <div className="upload-placeholder">
                  <span>Click to select an image</span>
                </div>
              )}
              <input 
                type="file" 
                name="image"
                id="image"
                accept="image/*"
                onChange={handleImageChange}
                className="file-input"
              />
            </div>
          </div>
          
          <div className="form-actions">
            <button 
              type="button" 
              className="cancel-btn" 
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className={`submit-btn ${loading ? 'loading' : ''}`}
            >
              {loading ? 'Updating...' : 'Update Offer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditOffer;